import React, { useContext, useEffect } from "react";
import { NavigationContext } from "../../context/NavigationContext";

export const withSubmissionEffect = (BaseComponent, navigationCallback) => {
  return ({ navigationsAway, canSubmit, values, ...props }) => {
    const navigationContext = useContext(NavigationContext);
    const primary = navigationsAway?.Primary;

    useEffect(() => {
      let navigateTo = primary;
      if (navigationCallback) {
        navigateTo = navigationCallback({
          navigationsAway,
          canSubmit,
          values,
          ...props,
        });
      }
      navigationContext.setOnSubmit(
        () => () => props.onSubmit(null, null, null, navigateTo, true)
      );
    }, [primary, canSubmit, navigationCallback]);

    return (
      <BaseComponent
        navigationsAway={navigationsAway}
        values={values}
        {...props}
      />
    );
  };
};
